export enum PAGE {
    HOME = 'home',
    SEARCH = 'search',
    NOT_FOUND = 'not-found',
    FAVORITES = 'favorites',
    CONTENT = 'content',
    RECENT = 'recent',
}
